import axios from 'axios';
import '../config.js';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

const base = (path) => `${global.config.url}/wallet${path}`;

const walletApi = {
  getAdminSettings: async (customerId) => (await axios.get(base(`/admin/customers/${customerId}/settings`), authConfig())).data,
  saveAdminSettings: async (customerId, settings) => (await axios.put(base(`/admin/customers/${customerId}/settings`), settings, authConfig())).data,
  getSupportCustomerSettings: async (customerId) => (await axios.get(base(`/support/customers/${customerId}/settings`), authConfig())).data,
  saveSupportCustomerSettings: async (customerId, settings) => (await axios.put(base(`/support/customers/${customerId}/settings`), settings, authConfig())).data,
  sendSupportCustomerTestPass: async (customerId, request) => (await axios.post(base(`/support/customers/${customerId}/test-pass`), request, authConfig())).data,
  getLocationAvailability: async (locationId) => (await axios.get(base(`/support/availability/${locationId}`), authConfig())).data,
  getLocationAccessPoints: async (locationId) => (await axios.get(base(`/support/locations/${locationId}/access-points`), authConfig())).data,
  saveLocationPortalCode: async (locationId, code) => (await axios.put(base(`/support/locations/${locationId}/portal-code`), { code }, authConfig())).data,
  uploadLogo: async (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return (await axios.post(base(`/support/customers/${customerId}/logo`), formData, authConfig())).data;
  },
  uploadGoogleLogo: async (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return (await axios.post(base(`/support/customers/${customerId}/google-logo`), formData, authConfig())).data;
  },
  uploadPassImage: async (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return (await axios.post(base(`/support/customers/${customerId}/pass-image`), formData, authConfig())).data;
  },
  getPasses: async (locationId) => (await axios.get(base(`/support/locations/${locationId}/passes`), authConfig())).data,
  createPass: async (locationId, pass) => (await axios.post(base(`/support/locations/${locationId}/passes`), pass, authConfig())).data,
  revokePass: async (locationId, passId) => axios.delete(base(`/support/locations/${locationId}/passes/${passId}`), authConfig()),
};

export default walletApi;